import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

import { zoomSvg } from '../../svgs';

import { SearchForm } from './styled';

const SearchBox: React.FC<any> = ({close} ) => {
  const { t } = useTranslation();
  
  const input = useRef(null);
  const [searchValue, setSearchValue] = useState("");

  let navigate = useNavigate();

  const handleSearch = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (searchValue && searchValue.length >= 3) {
        navigate("/?q=" + searchValue);
      }
  };

  const clearValue = (e) => {
    e.preventDefault();
    e.stopPropagation();

    input.current.value = '';
    input.current.focus();
    setSearchValue('');
  };
  
  // clear search if not querying 
  let location = useLocation();
  const parsedSearch = queryString.parse(location.search);
  useEffect(()=> {
    if(!parsedSearch.q) {
      setSearchValue('')
    }
  },[location.search]);


  return (
    <SearchForm  >
      <button className="search-submit" title="ძებნა" onMouseUp={(e) => handleSearch(e)}>
        {zoomSvg()}
      </button>

      <input 
        placeholder={t("findBlog")}
        onKeyPress={(e) => e.key === 'Enter' && handleSearch(e)}
        onChange={(e) => setSearchValue(e.target.value)}
        onFocus={close}
        value={searchValue}
        ref={input}
      />
      
      {/* <button className={`clear ${searchValue.length > 0 && 'active'} `} onMouseUp={clearValue}>
        {closeSvg()}
      </button> */}
    </SearchForm>
  );
};

export default SearchBox;
